<template>
  <div
    :class="[
      'v-input v-input__select',
      isDirty ? 'v-input--is-dirty' : '',
      disabled ? 'v-input--is-disabled' : '',
      selectToggleState ? 'v-input__select--is-open' : '',
      !!errors.has(newName) ? 'v-input__error--border' : '',
    ]"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <label class="v-input__label" v-if="label">{{ label }}</label>
    <Select2
      v-if="!form || form.length === 0"
      v-model="model"
      :name="name"
      :id="id"
      :disabled="disabled"
      :index="index"
      @blur="setSelectFalse"
      @mouseup="toggleSelect"
      @change="$emit('input', model), toggleSelect, $emit('change', model)"
      class="v-select-search"
      :settings="{
        containerCssClass:
          'v-input__field fontawesome-select' +
          (selectToggleState ? ' v-input__select--is-open' : '') +
          (showCreate ? ' select-show-create-link' : ''),
        dropdownAutoWidth: true,
      }"
      :options="orderedOptions"
    />
    <Select2
      v-else
      v-model="model"
      :form="form"
      :name="name"
      :id="id"
      :disabled="disabled"
      :index="index"
      @blur="setSelectFalse"
      @mouseup="toggleSelect"
      @change="$emit('input', model), toggleSelect, $emit('change', model)"
      class="v-select-search"
      :settings="{
        containerCssClass:
          'v-input__field fontawesome-select' +
          (selectToggleState ? ' v-input__select--is-open' : '') +
          (showCreate ? ' select-show-create-link' : ''),
        dropdownAutoWidth: true,
      }"
      :options="orderedOptions"
    />
    <v-modal-link
      :href="createUrl"
      v-if="showCreate"
      @get-result="getCurrentItem($event)"
      style="
        position: absolute;
        top: 3px;
        right: 0px;
        width: 25px;
        height: 100%;
      "
    >
      <i class="material-icons" style="padding-top: 10px">add</i>
    </v-modal-link>

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";
import Select2 from "v-select2-component";
import VModalLink from "./VModalLink";

export default {
  components: {
    Select2,
    VModalLink,
  },
  data() {
    return {
      selectToggleState: false,
    };
  },
  computed: {
    isDirty() {
      return this.model !== null;
    },
    orderedOptions() {
      var oo = this.sortProperties(this.options, this.sortBy, this.order);
      var sorted = oo.map(function (key, index) {
        return (oo[index] = { id: key[0], text: key[1] });
      });
      if(this.showZeroOption==1){
        sorted.unshift({ id: 0, text: this.zeroOption });
      }
      return sorted;
    },
  },
  mixins: [field],
  created() {
    let that = this;

    this.$root.$on("updateModel", (res) => {
      if (res && res.ref) {
        var valueLang =
          window.app.locale != "nl" ? res.metadata.value_lang[window.app.locale] : res.metadata.value_lang.nl;
        Vue.set(that.options, res.metadata.id, valueLang);
        if(that.id == res.ref){
          that.model = res.metadata.id;
        }
      } else if (res && res.value_lang) {
        let numberOfDaysVal = res.attribute.number_of_days,
          valueLang = "",
          category = res.attribute.category_id,
          paymentConditions = null,
          services = null;

        valueLang =
          window.app.locale === "nl" ? res.value_lang.nl : res.value_lang.en;
        paymentConditions = window.app.data
          ? window.app.data.paymentConditions
          : window.app.paymentConditions;
        services = window.app.data
          ? window.app.data.services
          : window.app.services;

        if (numberOfDaysVal) {
          Vue.set(paymentConditions, numberOfDaysVal, valueLang);
          that.model = numberOfDaysVal;
        } else {
          Vue.set(services, res.id, valueLang);

          if (
            `buying_prices[${that.index}][service]` ===
            $(".v-table__cell--services.current").find("select").attr("name")
          ) {
            that.model = res.id;
          }
        }
      }
      if (res && res.names) {
        let valueLang = "",
          selectOptions = null;

        valueLang = window.app.locale === "nl" ? res.names.nl : res.names.en;
        selectOptions = window.app.data
          ? window.app.data.selectOptions
          : window.app.selectOptions;

        Vue.set(selectOptions, res.id, valueLang);
        that.model = res.id;
      }
    });
  },
  props: {
    options: {
      default: () => {
        return {};
      },
      type: [Object, Array],
    },
    zeroOption: {
      default() {
        return "";
      },
      type: String,
    },
    showZeroOption: {
      default() {
        return "0";
      },
      type: String,
    },
    form: {
      default() {
        return "";
      },
      type: String,
    },
    id: {
      default: "",
      type: String,
    },
    sort: {
      default: false,
      type: Boolean,
    },
    sortBy: {
      default: "key",
      type: String,
    },
    order: {
      default: "asc",
      type: String,
    },
    createUrl: {
      default: "#",
      type: String,
    },
    showCreate: {
      default: true,
      type: Boolean,
    },
    index: {
      default: 0,
      type: Number,
    },
  },
  watch: {
    errors: function (value) {},
  },
  methods: {
    toggleSelect() {
      return this.selectToggleState
        ? this.setSelectFalse()
        : this.setSelectTrue();
    },
    setSelectTrue() {
      return (this.selectToggleState = true);
    },
    setSelectFalse() {
      return (this.selectToggleState = false);
    },
    sortProperties(obj, sortBy, order) {
      var sortable = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          sortable.push([key, obj[key]]);
        }
      }
      if (sortBy == "key") {
        sortable.sort(function (a, b) {
          var x = parseInt(a[0]),
            y = parseInt(b[0]);
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      } else {
        sortable.sort(function (a, b) {
          var x = a[1].toLowerCase(),
            y = b[1].toLowerCase();
          return order == "desc"
            ? x > y
              ? -1
              : x < y
              ? 1
              : 0
            : x < y
            ? -1
            : x > y
            ? 1
            : 0;
        });
      }
      return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
    },
    getCurrentItem(event) {
      $(".v-table__cell--services").removeClass("current");
      $(event.target).parents(".v-table__cell--services").addClass("current");
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/admin/components/VSelectSearch.vue